import { ReactNode } from 'react';
import { isEqual } from 'lodash/fp';
import { WithAccountId, WithEnterpriseId } from '@mews-commander/types';
import { Stack } from '@optimus-web/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { BillingMode } from '../../../constants';
import { BillCardList } from '../../../BillCardList';
import { BillListHeader, NewBillButton } from '../../../components';
import { getAmountDueForBillIds } from '../../../selectors';
import { AccountBillCardEmptyState } from './AccountBillCardEmptyState';

interface AccountBillCardGroupProps extends WithAccountId, WithEnterpriseId {
    title: ReactNode;
    billIds: string[];
    showEmptyState?: boolean;
    showNewButton?: boolean;
}

export const AccountBillCardGroup: React.FC<AccountBillCardGroupProps> = ({
    title,
    billIds,
    accountId,
    enterpriseId,
    showEmptyState,
    showNewButton,
}) => {
    const { totalAmount, billAmounts } = useCommanderSelector(
        (state) => getAmountDueForBillIds(state, { enterpriseId, billIds }),
        isEqual
    );

    return (
        <Stack vertical spacing="200">
            <BillListHeader
                buttons={showNewButton ? [<NewBillButton key="NewBillButton" accountId={accountId} />] : []}
                amount={totalAmount}
                title={title}
            />

            {showEmptyState && <AccountBillCardEmptyState />}

            <BillCardList
                billIds={billIds}
                billAmounts={billAmounts}
                mode={BillingMode.AccountBilling}
                accountId={accountId}
            />
        </Stack>
    );
};
